<template>
    <div class="list-container">
        <h2>Manage Front Desk Accounts</h2>
        <button class="btn btn-sm add-btn" @click="$router.push('/dashboard/frontdesk/create')">Add Front Desk
            Account</button>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>

        <ul v-else class="data-list">
            <li v-for="frontdesk in frontdeskAccounts" :key="frontdesk.id" class="list-item "
                :class="{ 'bg-disabled': !frontdesk.user.is_active }">
                <div class="item-info">
                    <span class="info-item"><strong>Name:</strong> {{ frontdesk.user.name }}</span>
                    <span class="info-item"><strong>Email:</strong> {{ frontdesk.user.email }}</span>
                    <!-- <span class="info-item"><strong>Specialization:</strong> {{ frontdesk.specialization || 'N/A' -->
                    <!-- }}</span> -->
                    <span class="info-item"><strong>Active:</strong> {{ frontdesk.user.is_active ? 'Yes' : 'No'
                        }}</span>
                </div>
                <div class="btn-group">
                    <button class="btn btn-sm edit-btn"
                        @click="$router.push(`/dashboard/frontdesk/edit/${frontdesk.id}`)">✏️ Edit</button>
                    <button class="btn btn-sm delete-btn" @click="deleteFrontDesk(frontdesk.id)"
                        v-if="frontdesk.user.is_active">Disable</button>
                    <button class="btn btn-sm " @click="deleteFrontDesk(frontdesk.id)" v-else>
                        Enable</button>
                </div>
            </li>
        </ul>
    </div>
</template>



<script>

export default {
    data() {
        return {
            frontdeskAccounts: [],
            loading: false
        };
    },
    methods: {
        async fetchFrontDeskAccounts() {
            this.loading = true;
            try {
                this.frontdeskAccounts = [];
                const response = await this.$api.get('/frontdesks');
                this.frontdeskAccounts = response.data;

            } catch (error) {
                console.error("Error fetching front desk accounts:", error);
            }
            this.loading = false;
        },
        async deleteFrontDesk(id) {
            if (!confirm("Are you sure you want to disable this front desk account?")) return;
            try {
                let frontdesk = this.frontdeskAccounts.find(frontdesk => frontdesk.id == id);
                let c = { is_active: 1 - frontdesk.user.is_active };
                await this.$api.put(`/frontdesks/${id}`, c);
                frontdesk.user.is_active = c.is_active;

                // this.counselors = this.counselors.filter(counselor => counselor.id !== id);
            } catch (error) {
                console.error("Error deactivating front desk account:", error);
            }
        }
    },
    mounted() {
        this.fetchFrontDeskAccounts();
    }
};
</script>

<style scoped>
.counselors-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.7);
}

.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid #1DBCBC;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

ul.counselor-list {
    list-style: none;
    padding: 0;
    margin-top: 20px;
}

.counselor-list li {
    background: #f4f7fc;
    padding: 10px;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
}

.btn-group {
    display: flex;
    gap: 10px;
}
</style>